/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LegalBypassReason = {
    ProjectAboutToStart: 'PROJECT_ABOUT_TO_START',
    MangopayVerificationsTakeTooLong: 'MANGOPAY_VERIFICATIONS_TAKE_TOO_LONG',
    MangopayVerificationsTakeTooManyBackAndForth: 'MANGOPAY_VERIFICATIONS_TAKE_TOO_MANY_BACK_AND_FORTH',
    FreelancerBusinessNotRegisteredYet: 'FREELANCER_BUSINESS_NOT_REGISTERED_YET',
    FreelancerBusinessJustRegistered: 'FREELANCER_BUSINESS_JUST_REGISTERED',
    Other: 'OTHER'
} as const;
export type LegalBypassReason = typeof LegalBypassReason[keyof typeof LegalBypassReason];


export function instanceOfLegalBypassReason(value: any): boolean {
    for (const key in LegalBypassReason) {
        if (Object.prototype.hasOwnProperty.call(LegalBypassReason, key)) {
            // @ts-ignore
            if (LegalBypassReason[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LegalBypassReasonFromJSON(json: any): LegalBypassReason {
    return LegalBypassReasonFromJSONTyped(json, false);
}

export function LegalBypassReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalBypassReason {
    return json as LegalBypassReason;
}

export function LegalBypassReasonToJSON(value?: LegalBypassReason | null): any {
    return value as any;
}

